<template>
  <div class="index">
    <div class="d-flex justify-content-center">
      <div class="box login text-center">
        <h3>Lokalna prijava</h3>
        <div>(KVALIFICIRANO DIGIT. POTRDILO)</div>
        <div class="padding-top60">
          <a class="button" href @click.prevent="$router.push({ name: 'login' })">VSTOP</a>
        </div>
      </div>
      <div class="box login margin-left40 text-center">
        <h3>Centralna prijava</h3>
        <div>(SI-PASS)</div>
        <div class="padding-top60">
          <a class="button sipass" href="/sipass"> &nbsp; &nbsp; VSTOP</a>
        </div>
      </div>
    </div>
    <div v-if="sipassError" class="toast toast-error margin-top20">SI-PASS prijava ni uspela. Poizkusite znova čez nekaj minut.</div>
    <div class="padding-top10">
      <NewsTop />
    </div>
  </div>
</template>
<script lang="ts">
import { errorMap } from '@/lib/filters'
import { useApi } from '@/lib/api'
import { useStore } from 'vuex'
import { GlobalState } from '@/lib/types'
import { useRouter, useRoute } from 'vue-router'
import { defineComponent, ref, onMounted } from 'vue'
import NewsTop from '@/components/NewsTop.vue'

export default defineComponent({
  components: { NewsTop },
  setup() {
    const _api = useApi()
    const _store = useStore<GlobalState>()
    const _router = useRouter()
    const _route = useRoute()
    const data = ref({})
    const sipassError = ref(false)

    const certReg = async () => {
      const res = await _api.get<any>('cert')
      if (res.status === 200) {
        _router.push({ name: 'registration' })
      }
    }

    const checkLoginUrl = async (url: any) => {
      const res = await _api.post<any>('loginUrlCheck', { loginUrl: url })
      if (res.status === 200) {
        _store.commit('user', res.data)
        _router.push({ name: 'userProfile' })
      }
    }

    const checkChangeCert = async (url: any) => {
      try {
        const res = await _api.post<any>('certChange', { loginUrl: url })
        if (res.status === 200) {
          _store.commit('user', res.data)
          _router.push({ name: 'reportList' })
        } else if (res.status === 403) {
          _store.commit('appErrors', [{ key: '.', message: 'Izbrano je nekvalificirano potrdilo' }])
        }
      } catch (e) {
        if (e.response.status === 403) {
          _store.commit('appErrors', [{ key: '.', message: 'Izbrano je nekvalificirano potrdilo' }])
        }
      }
    }

    onMounted(() => {
      if (_route.query.sipasserr) {
        sipassError.value = true
      } else if (_route.query.l) {
        checkLoginUrl(_route.query.l)
      } else if (_route.query.c) {
        checkChangeCert(_route.query.c)
      }
    })

    return { data, errorMap, certReg, sipassError }
  }
})
</script>
<style lang="scss" scoped>
.index {
  padding-top: 290px;
  padding-left: 35px;
  padding-right: 35px;
  background: url('../assets/bgIndex.png') 0 -90px no-repeat #fff;

  .box h3 {
    font-size: 18px;
    font-weight: normal;
    color: #111;
  }

  .box.login {
    min-width: 335px;
    height: 195px;
  }
}
</style>
